import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
var InformationComponent = (function () {
    function InformationComponent(activeModal) {
        this.activeModal = activeModal;
    }
    return InformationComponent;
}());
export { InformationComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/core/information/information.component.ts.pre-build-optimizer.js